import React from 'react';
import {Table, Input, Button, Icon} from 'antd';
import StationButtonUpdate from './StationButtonUpdate';
import StationButtonGroupUpdate from './StationButtonGroupUpdate';
import StationButtonDelete from './StationButtonDelete';
import StationButtonCamera from './StationButtonCamera';
import {roleStationManagement, UUID_NULL} from '../constants/defaultValues'
import {locdau} from '../utils'

const getGroupNames = (stations) => {
  const values = stations.filter(item => (item.GroupName)).map((item) => {
    return {text: item.GroupName, value: item.GroupID}
  }).filter((s, index, arr) => arr.findIndex((t) => {
    return (t.value === s.value)
  }) === index)
  return values.concat({text: "Chưa cài đặt", value: UUID_NULL})
}

const highlight = {
  color: '#003a8c'
}

class StationTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stations: this.props.stations,
      selectedRowKeys: [],
      nameFilterVisible: false,
      nameSearchText: '',
      nameFiltered: false,
      hardwareIDFilterVisible: false,
      hardwareIDSearchText: '',
      hardwareIDFiltered: false
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({stations: nextProps.stations})
  }

  onSelectChange = (selectedRowKeys) => {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({selectedRowKeys});
  }

  handleNameInputChange = (e) => {
    this.setState({nameSearchText: e.target.value});
  };

  handleNameSearch = () => {
    const {nameSearchText} = this.state
    const {stations} = this.props
    const filterStations = stations.filter((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(nameSearchText).toLowerCase()
      const index = kodau.indexOf(kodauSearch);
      return index > -1
    }).map((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(nameSearchText).toLowerCase()
      const index = kodau.indexOf(kodauSearch);
      const beforeStr = item.Name.substr(0, index);
      const matchStr = item.Name.substr(index, nameSearchText.length);
      const afterStr = item.Name.substr(index + nameSearchText.length);
      const title = (<span>
        {beforeStr}
        <span className="highlight">{matchStr}</span>
        {afterStr}
      </span>)
      return {
        ...item,
        Title: title
      };
    })

    this.setState({
      nameFilterVisible: false,
      nameFiltered: !!nameSearchText,
      hardwareIDFiltered: false,
      hardwareIDSearchText: "",
      stations: filterStations
    });
  };

  handleHardwareIDInputChange = (e) => {
    this.setState({hardwareIDSearchText: e.target.value});
  };

  handleHardwareIDSearch = () => {
    const {hardwareIDSearchText} = this.state
    const {stations} = this.props
    const filterStations = stations.filter((item) => {
      const lower = item.HardwareIDHex.toLowerCase()
      const lowerSearch = hardwareIDSearchText.toLowerCase()
      const index = lower.indexOf(lowerSearch);
      return index > -1
    }).map((item) => {
      const lower = item.HardwareIDHex.toLowerCase()
      const lowerSearch = hardwareIDSearchText.toLowerCase()
      const index = lower.indexOf(lowerSearch);
      const beforeStr = item.HardwareIDHex.substr(0, index);
      const matchStr = item.HardwareIDHex.substr(index, hardwareIDSearchText.length);
      const afterStr = item.HardwareIDHex.substr(index + hardwareIDSearchText.length);
      const title = (<span>
        {beforeStr}
        <span className="highlight">{matchStr}</span>
        {afterStr}
      </span>)
      return {
        ...item,
        HardwareIDTitle: title
      };
    })
    this.setState({
      hardwareIDFilterVisible: false,
      hardwareIDFiltered: !!hardwareIDSearchText,
      nameFiltered: false,
      nameSearchText: "",
      stations: filterStations
    });
  };

  handleDelete = (station) => {
    this.props.onDelete(station)
  }

  handleUpdate = (station) => {
    const {onUpdate} = this.props
    onUpdate(station)
  }

  handleStationButtonCamera = (station) => {
    const {onStationButtonCamera} = this.props
    onStationButtonCamera(station)
  }

  render() {
    const {role, fetching, groups, treeGroups} = this.props
    const {
      stations,
      selectedRowKeys,
      nameFiltered,
      nameSearchText,
      nameFilterVisible,
      hardwareIDFiltered,
      hardwareIDSearchText,
      hardwareIDFilterVisible
    } = this.state
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    };
    const filterGroupNames = getGroupNames(stations)
    const columns = [
      {
        title: 'STT',
        key: 'seq',
        render: (text, station, i) => (i + 1)
      }, {
        title: 'Tên',
        dataIndex: 'Name',
        render: (text, station, i) => (
          station.Title
          ? station.Title
          : station.Name),
        key: 'name',
        filterDropdown: (<div className="table-filter-dropdown">
          <Input ref={ele => this.nameSearchInput = ele} placeholder="Nhập tên" value={nameSearchText} onChange={this.handleNameInputChange} onPressEnter={this.handleNameSearch}/>
          <Button type="primary" onClick={this.handleNameSearch}>Tìm</Button>
        </div>),
        filterIcon: <Icon type="search" style={nameFiltered
            ? highlight
            : null}/>,
        filterDropdownVisible: nameFilterVisible,
        onFilterDropdownVisibleChange: visible => this.setState({
          nameFilterVisible: visible
        }, () => this.nameSearchInput.focus())
      }, {
        title: 'Mã',
        dataIndex: 'HardwareIDHex',
        render: (text, station, i) => (
          station.HardwareIDTitle
          ? station.HardwareIDTitle
          : station.HardwareIDHex),
        key: 'hardwareidhex',
        filterDropdown: (<div className="table-filter-dropdown">
          <Input ref={ele => this.hardwareIDSearchInput = ele} placeholder="Nhập mã" value={hardwareIDSearchText} onChange={this.handleHardwareIDInputChange} onPressEnter={this.handleHardwareIDSearch}/>
          <Button type="primary" onClick={this.handleHardwareIDSearch}>Tìm</Button>
        </div>),
        filterIcon: <Icon type="search" style={hardwareIDFiltered
            ? highlight
            : null}/>,
        filterDropdownVisible: hardwareIDFilterVisible,
        onFilterDropdownVisibleChange: visible => this.setState({
          hardwareIDFilterVisible: visible
        }, () => this.hardwareIDSearchInput.focus())
      }, {
        title: 'Địa bàn',
        dataIndex: 'GroupName',
        key: 'groupname',
        filters: filterGroupNames,
        onFilter: (value, record) => (record.GroupID === value)
      }, {
        title: '...',
        key: 'action',
        render: (text, station) => (<span>
          <StationButtonUpdate station={station} stations={stations} onUpdate={this.handleUpdate}/> {
            roleStationManagement(role)
              ? <span className="ant-divider"/>
              : null
          }
          {
            roleStationManagement(role)
              ? <StationButtonGroupUpdate station={station} groups={groups} treeGroups={treeGroups} onUpdate={this.handleUpdate}/>
              : null
          }
          <span className="ant-divider"/>
          <StationButtonCamera station={station} onStationButtonCamera={this.handleStationButtonCamera}/> {
            roleStationManagement(role)
              ? <span>
                  <span className="ant-divider"/>
                  <StationButtonDelete station={station} onDelete={this.handleDelete}/></span>
              : null
          }
        </span>)
      }
    ];
    return <Table columns={columns} dataSource={stations} rowKey={station => station.ID} rowSelection={rowSelection} loading={fetching}/>
  }
}

export default StationTable



// WEBPACK FOOTER //
// ./src/components/StationTable.js